<template>
  <div class="card events-card" v-bind:style="style">
    <div class="card-content">
      <div class="card-header-title">Avis</div>

      <div class="field has-addons">
        <div class="control" style="width:100%;">
          <input
              class="input"
              placeholder="recherche texte: avis, auteur ..."
              v-model="search_string"
          />
        </div>
        <div class="control">
          <a class="button">Rechercher</a>
        </div>
      </div>

      <!-- .dummy -->
      <!-- {{establishment}} {{establishment.name}} -->

      <div class="field">
        <label>
          <input type="checkbox" v-model="classified" />
          <span>&nbsp;Classé</span>
        </label>
      </div>

      <DropDownSearch
          :items="establishments"
          v-on:dropdownClick="establishmentClicked"
          :currentValue="establishment"
          defaultLabel="Etab."
      />

      <DropDownSearch
          :items="sentiments"
          v-on:dropdownClick="sentimentClicked"
          :currentValue="sentiment"
          defaultLabel="Sentiment"
      />

      <DropDownSearch
          :items="platforms"
          v-on:dropdownClick="platformClicked"
          :currentValue="platform"
          defaultLabel="Plateforme"
      />

      <DropDownSearch
          v-if="status_set!=null"
          :items="status_set"
          v-on:dropdownClick="stateClicked"
          :currentValue="status"
          defaultLabel="Statut"
      />

      <DropDownSearch
          v-if="status_set!=null"
          :items="tag_set"
          v-on:dropdownClick="tagClicked"
          :currentValue="tag"
          defaultLabel="Tag"
      />

      <DropDownSearch
          :items="consultants"
          v-on:dropdownClick="consultantClicked"
          :currentValue="consultant"
          defaultLabel="Consultant"
          shownKey="fullname"
      />

      <input
          id="has_game"
          type="checkbox"
          name="has_game"
          class="switch is-small"
          v-model="has_game_filter"
      />
      <label class="label" for="has_game">Partie en cours</label>

      <div class="field has-addons">
        <p class="control">
          <button class="button is-small" disabled>Du</button>
        </p>
        <p class="control">
          <input
              class="input is-small"
              type="date"
              v-model="dateBegin"
              @change="dateBeginClicked"
          />
        </p>
        <p class="control">
          <input
              class="input is-small"
              type="date"
              v-model="dateEnd"
              @change="dateEndClicked"
          />
        </p>
      </div>
    </div>

    <ReviewListPaginatedForSimulation
        :filters="filters"
        :height="listHeight"
        :autoload="true"
        title=""
        @select_review="select_review"
    />
  </div>
</template>


<script>
import ReviewListPaginatedForSimulation from '@/components/ReviewListPaginatedForSimulation';
import DropDownSearch from '@/components/ui/DropDownSearch';
import gql from '@/gqlService.coffee';
import utils from '@/utils.js';
import queries from "@/gql/queries.coffee";
import 'bulma-switch';

export default {
  name: 'ReviewListFilterFlowSimulation',
  components: {
    ReviewListPaginatedForSimulation,
    DropDownSearch
  },
  props: {},
  data() {
    return {
      dateBegin: null,
      dateEnd: null,
      has_game_filter: false,
      status_set: null,
      tag: { name: null },
      tag_set: [
        { name: 'Supprimé', code: 'deleted' },
        { name: 'Répondu', code: 'answered' },
        { name: 'Impossible', code: 'Impossible' }
      ],
      status: { name: null, uid: null },
      sentiments: [
        { name: 'Positif', value: true },
        { name: 'Négatif', value: false }
      ],
      sentiment: { name: null, value: null },
      classified: false,
      height: (window.innerHeight - 30) + "px",
      listHeight: (window.innerHeight - 260) + "px",
      late: false,
      search_string: "",
      platform: { name: null },
      platforms: gql.query({
        model: "platform_set",
        fields: "uid name"
      }),
      establishment: { name: null },
      establishments: gql.query({
        model: "establishment_set",
        fields: "uid name",
        filters: "active: true"
      }),
      consultant: { lastname: null },
      consultants: gql.query({
        model: "consultant_set",
        fields: "uid lastname firstname fullname"
      })
    };
  },
  computed: {
    style() {
      return {
        height: this.height
      };
    },
    filters() {
      return {
        status: this.status,
        sentiment: this.sentiment,
        classified: this.classified,
        late: this.late,
        platform: this.platform,
        establishment: this.establishment,
        consultant: this.consultant,
        search_string: this.search_string,
        dateBeginFilter: this.dateBegin,
        dateEndFilter: this.dateEnd,
        tag: this.tag,
        has_game_filter: this.has_game_filter
      };
    }
  },
  methods: {
    select_review(uid) {
      this.$emit('select_review', uid);
    },
    tagClicked(item) {
      this.tag = item || { name: null };
    },
    dateBeginClicked(item) {
      // console.log("item", item);
    },
    dateEndClicked(item) {
      // console.log("item", item);
    },
    sentimentClicked(item) {
      this.sentiment = item || { name: null, value: null };
    },
    platformClicked(item) {
      this.platform = item || { name: null };
    },
    establishmentClicked(item) {
      console.log("establishmentClicked", item);
      this.establishment = item || { name: null };
      console.log("establishmentClicked", this.establishment);
    },
    consultantClicked(item) {
      this.consultant = item || { lastname: null };
    },
    stateClicked(item) {
      this.status = item || { name: null, value: null };
      this.classified = this.status.value === "Classified";
    },
    setHeight: utils.debounce(function () {
      this.height = (window.innerHeight - 30) + "px";
      this.listHeight = (window.innerHeight - 260) + "px";
    }, 500)
  },
  async mounted() {
    this.setHeight();
    window.addEventListener('resize', this.setHeight);
    const data = await queries.run("named_state_set");
    this.status_set = data.body.data.named_state_set;
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.setHeight);
  }
};
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.drop{
    width:33%;
}
.card-content{
    padding:10px;
}
.card-header-title{
    padding:0 0 10px 0;
}

</style>
